import { ReplicaType } from "types";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp4-harry-potters-secret-heartache",
  name: `The Daily Prophet\n'Harry Potter's Secret Heartache'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Harry Potter's Secret Heartache'",
  },
  origin: "Harry Potter and the Goblet of Fire",

  category: replicaCategories.harryPotter,

  versions: [Version2],
};

export default data;
